import { IAxios } from "../conf";

const baseEndpoint = "Medidas/";

const GetMedidasList = async (idMedida) => {
  const endpoint = baseEndpoint + idMedida;
  return await IAxios.get(endpoint);
};

const PostMedida = async (medida) => {
  return await IAxios.post(baseEndpoint, medida);
};

const GetMedidas = async (idMedida) => {
  return await IAxios.get(baseEndpoint, idMedida);
};

const PutMedida = async (idMedida) => {
  return await IAxios.put(baseEndpoint, idMedida);
};

const DeleteMedida = async (idMedida) => {
  return await IAxios.delete(baseEndpoint, idMedida);
};

const ApiMedidas = {
  GetMedidasList,
  PostMedida,
  GetMedidas,
  PutMedida,
  DeleteMedida,
};

export default ApiMedidas;
